<template>
  <div>
    
    <!-- rest of template -->
    <div
      id="wrap"
      style="background: #f8fafc; min-height: 100vh; font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;"
    >
      <LayoutHeader />

      <div id="main" style="">
    <ServicesServiceHero
      title="Migration to AWS Cloud"
      description="Seamless transition to the cloud with minimal disruption and maximum value"
      icon="🚀"
      gradient="aws-migration"
    />

        <!-- Main Content -->
        <div class="container" style="max-width: 1000px">
          <div class="row">
            <div class="col-md-12">
              <div class="service-main-card">
                <h2
                  style="
                    color: #1a202c;
                    font-weight: 700;
                    margin-bottom: 24px;
                    font-size: 2.2rem;
                  "
                >
                  Transform Your Business with AWS Cloud 🌥️
                </h2>
                <p
                  style="
                    color: #4a5568;
                    line-height: 1.7;
                    font-size: 1.1rem;
                    margin-bottom: 40px;
                  "
                >
                  Moving to the AWS Cloud is more than just relocating your
                  infrastructure—it's about transforming how your business
                  operates. Our AWS migration services help you navigate this
                  journey with confidence, ensuring a smooth transition that
                  minimizes disruption while maximizing the benefits of cloud
                  technology.
                </p>

                <h3
                  style="
                    color: #1a202c;
                    font-weight: 600;
                    margin-bottom: 30px;
                    font-size: 1.8rem;
                  "
                >
                  Our Migration Approach
                </h3>

                <div
                  style="
                    background: #f7fafc;
                    padding: 40px;
                    border-radius: 16px;
                    margin-bottom: 40px;
                  "
                >
                  <div class="row">
                    <div class="col-md-3 mb-4 mb-md-0">
                      <div style="text-align: center">
                        <div
                          style="
                            width: 80px;
                            height: 80px;
                            background: linear-gradient(
                              135deg,
                              var(--aws-migration-start),
                              var(--aws-migration-end)
                            );
                            color: white;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 auto 20px auto;
                            font-size: 32px;
                          "
                        >
                          1
                        </div>
                        <h5
                          style="
                            color: #1a202c;
                            font-weight: 600;
                            margin-bottom: 12px;
                          "
                        >
                          Assess
                        </h5>
                        <p
                          style="color: #4a5568; margin: 0; font-size: 0.95rem"
                        >
                          Evaluate your current infrastructure, applications,
                          and business objectives
                        </p>
                      </div>
                    </div>
                    <div class="col-md-3 mb-4 mb-md-0">
                      <div style="text-align: center">
                        <div
                          style="
                            width: 80px;
                            height: 80px;
                            background: linear-gradient(
                              135deg,
                              var(--aws-migration-start),
                              var(--aws-migration-end)
                            );
                            color: white;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 auto 20px auto;
                            font-size: 32px;
                          "
                        >
                          2
                        </div>
                        <h5
                          style="
                            color: #1a202c;
                            font-weight: 600;
                            margin-bottom: 12px;
                          "
                        >
                          Plan
                        </h5>
                        <p
                          style="color: #4a5568; margin: 0; font-size: 0.95rem"
                        >
                          Create a detailed migration strategy with prioritized
                          workloads
                        </p>
                      </div>
                    </div>
                    <div class="col-md-3 mb-4 mb-md-0">
                      <div style="text-align: center">
                        <div
                          style="
                            width: 80px;
                            height: 80px;
                            background: linear-gradient(
                              135deg,
                              var(--aws-migration-start),
                              var(--aws-migration-end)
                            );
                            color: white;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 auto 20px auto;
                            font-size: 32px;
                          "
                        >
                          3
                        </div>
                        <h5
                          style="
                            color: #1a202c;
                            font-weight: 600;
                            margin-bottom: 12px;
                          "
                        >
                          Migrate
                        </h5>
                        <p
                          style="color: #4a5568; margin: 0; font-size: 0.95rem"
                        >
                          Execute the migration with minimal disruption to your
                          operations
                        </p>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div style="text-align: center">
                        <div
                          style="
                            width: 80px;
                            height: 80px;
                            background: linear-gradient(
                              135deg,
                              var(--aws-migration-start),
                              var(--aws-migration-end)
                            );
                            color: white;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin: 0 auto 20px auto;
                            font-size: 32px;
                          "
                        >
                          4
                        </div>
                        <h5
                          style="
                            color: #1a202c;
                            font-weight: 600;
                            margin-bottom: 12px;
                          "
                        >
                          Optimize
                        </h5>
                        <p
                          style="color: #4a5568; margin: 0; font-size: 0.95rem"
                        >
                          Continuously improve your cloud environment for
                          performance and cost
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <h3
                  style="
                    color: #1a202c;
                    font-weight: 600;
                    margin-bottom: 30px;
                    font-size: 1.8rem;
                  "
                >
                  Migration Strategies (The 6 R's)
                </h3>

                <div class="row mb-5">
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔄 Rehost
                      </h4>
                      <p style="margin-bottom: 16px; line-height: 1.6">
                        "Lift and Shift" your applications to the cloud with
                        minimal changes
                      </p>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Fastest migration path</li>
                        <li>Minimal code changes</li>
                        <li>AWS Migration Hub</li>
                        <li>AWS Application Migration Service</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        ⚙️ Replatform
                      </h4>
                      <p style="margin-bottom: 16px; line-height: 1.6">
                        "Lift, Tinker, and Shift" to optimize for the cloud
                      </p>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Moderate code changes</li>
                        <li>Database migration to RDS</li>
                        <li>Containerization with ECS/EKS</li>
                        <li>Managed services adoption</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔧 Refactor
                      </h4>
                      <p style="margin-bottom: 16px; line-height: 1.6">
                        Reimagine your application architecture using
                        cloud-native features
                      </p>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Significant code changes</li>
                        <li>Serverless architecture</li>
                        <li>Microservices adoption</li>
                        <li>Maximum cloud benefits</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🛒 Repurchase
                      </h4>
                      <p style="margin-bottom: 16px; line-height: 1.6">
                        Switch to SaaS or different cloud products
                      </p>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Move to SaaS solutions</li>
                        <li>AWS Marketplace</li>
                        <li>Minimal migration effort</li>
                        <li>Business process changes</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔍 Retain
                      </h4>
                      <p style="margin-bottom: 16px; line-height: 1.6">
                        Keep applications in source environment
                      </p>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Hybrid cloud approach</li>
                        <li>AWS Direct Connect</li>
                        <li>AWS Storage Gateway</li>
                        <li>Phased migration</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🗑️ Retire
                      </h4>
                      <p style="margin-bottom: 16px; line-height: 1.6">
                        Decommission applications no longer needed
                      </p>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Reduce security risks</li>
                        <li>Cost savings</li>
                        <li>Portfolio rationalization</li>
                        <li>Data archiving</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <h3
                  style="
                    color: #1a202c;
                    font-weight: 600;
                    margin-bottom: 30px;
                    margin-top: 50px;
                    font-size: 1.8rem;
                  "
                >
                  AWS Migration Tools & Services
                </h3>

                <div
                  style="
                    background: linear-gradient(
                      135deg,
                      var(--aws-migration-start) 0%,
                      var(--aws-migration-end) 100%
                    );
                    color: white;
                    padding: 32px;
                    border-radius: 16px;
                    margin-bottom: 40px;
                  "
                >
                  <div class="row">
                    <div class="col-md-6 mb-4">
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔄 Migration & Transfer
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>
                          <strong>AWS Migration Hub</strong> - Track migration
                          progress across multiple tools
                        </li>
                        <li>
                          <strong>AWS Application Migration Service</strong> -
                          Lift-and-shift solution
                        </li>
                        <li>
                          <strong>AWS Database Migration Service</strong> -
                          Migrate databases with minimal downtime
                        </li>
                        <li>
                          <strong>AWS DataSync</strong> - Transfer data between
                          on-premises and AWS
                        </li>
                        <li>
                          <strong>AWS Snow Family</strong> - Physical devices
                          for large-scale data transfer
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6 mb-4">
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔍 Assessment & Planning
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>
                          <strong>AWS Application Discovery Service</strong> -
                          Discover on-premises applications
                        </li>
                        <li>
                          <strong>AWS Migration Evaluator</strong> - Build a
                          business case for cloud migration
                        </li>
                        <li>
                          <strong
                            >AWS Migration Hub Strategy Recommendations</strong
                          >
                          - Get migration strategy advice
                        </li>
                        <li>
                          <strong>AWS Well-Architected Tool</strong> - Review
                          workloads against best practices
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔐 Hybrid Connectivity
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>
                          <strong>AWS Direct Connect</strong> - Dedicated
                          network connection to AWS
                        </li>
                        <li>
                          <strong>AWS VPN</strong> - Secure connection between
                          on-premises and AWS
                        </li>
                        <li>
                          <strong>AWS Storage Gateway</strong> - Hybrid storage
                          integration
                        </li>
                        <li>
                          <strong>AWS Outposts</strong> - AWS infrastructure
                          on-premises
                        </li>
                      </ul>
                    </div>
                    <div class="col-md-6">
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        ⚙️ Modernization
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>
                          <strong>AWS App2Container</strong> - Containerize and
                          migrate applications
                        </li>
                        <li>
                          <strong>AWS Elastic Beanstalk</strong> - Easy
                          application deployment
                        </li>
                        <li>
                          <strong>AWS Lambda</strong> - Serverless compute
                          service
                        </li>
                        <li>
                          <strong>Amazon ECS/EKS</strong> - Container
                          orchestration services
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <h3
                  style="
                    color: #1a202c;
                    font-weight: 600;
                    margin-bottom: 30px;
                    margin-top: 50px;
                    font-size: 1.8rem;
                  "
                >
                  Migration Benefits
                </h3>

                <div class="row mb-5">
                  <div class="col-md-6 mb-4">
                    <div
                      style="
                        background: #f7fafc;
                        padding: 24px;
                        border-radius: 12px;
                        border-left: 4px solid var(--aws-migration-start);
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          color: #1a202c;
                          font-weight: 600;
                          margin-bottom: 12px;
                        "
                      >
                        💰 Cost Optimization
                      </h4>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6">
                        Reduce capital expenses and pay only for what you use
                        with flexible pricing models. Typical cost savings of
                        30-50% compared to on-premises infrastructure.
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div
                      style="
                        background: #f7fafc;
                        padding: 24px;
                        border-radius: 12px;
                        border-left: 4px solid var(--aws-migration-start);
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          color: #1a202c;
                          font-weight: 600;
                          margin-bottom: 12px;
                        "
                      >
                        ⚡ Agility & Innovation
                      </h4>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6">
                        Deploy new applications in minutes instead of months.
                        Experiment quickly and transform ideas into reality with
                        over 200 fully-featured AWS services.
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div
                      style="
                        background: #f7fafc;
                        padding: 24px;
                        border-radius: 12px;
                        border-left: 4px solid var(--aws-migration-start);
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          color: #1a202c;
                          font-weight: 600;
                          margin-bottom: 12px;
                        "
                      >
                        📈 Scalability
                      </h4>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6">
                        Scale resources up or down automatically based on
                        demand. Eliminate capacity planning headaches and
                        respond instantly to business changes.
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div
                      style="
                        background: #f7fafc;
                        padding: 24px;
                        border-radius: 12px;
                        border-left: 4px solid var(--aws-migration-start);
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          color: #1a202c;
                          font-weight: 600;
                          margin-bottom: 12px;
                        "
                      >
                        🔒 Security & Compliance
                      </h4>
                      <p style="color: #4a5568; margin: 0; line-height: 1.6">
                        Benefit from AWS's comprehensive security features and
                        compliance certifications. Automate security tasks and
                        implement best practices at scale.
                      </p>
                    </div>
                  </div>
                </div>

                <h3
                  style="
                    color: #1a202c;
                    font-weight: 600;
                    margin-bottom: 30px;
                    margin-top: 50px;
                    font-size: 1.8rem;
                  "
                >
                  Our Migration Services
                </h3>

                <div class="row mb-5">
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔍 Assessment & Discovery
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Application portfolio analysis</li>
                        <li>TCO and ROI calculations</li>
                        <li>Dependency mapping</li>
                        <li>Migration readiness assessment</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        📝 Planning & Design
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Migration strategy development</li>
                        <li>Landing zone design</li>
                        <li>Security & compliance planning</li>
                        <li>Application prioritization</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-4 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🚀 Migration Execution
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Workload migration</li>
                        <li>Data transfer & validation</li>
                        <li>Testing & validation</li>
                        <li>Cutover planning & execution</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🔧 Optimization
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>Performance tuning</li>
                        <li>Cost optimization</li>
                        <li>Architectural improvements</li>
                        <li>Automation implementation</li>
                        <li>Well-Architected reviews</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-6 mb-4">
                    <div
                      style="
                        background: linear-gradient(
                          135deg,
                          var(--aws-migration-start) 0%,
                          var(--aws-migration-end) 100%
                        );
                        color: white;
                        padding: 32px;
                        border-radius: 16px;
                        height: 100%;
                      "
                    >
                      <h4
                        style="
                          font-weight: 700;
                          margin-bottom: 16px;
                          font-size: 1.3rem;
                        "
                      >
                        🛠️ Managed Services
                      </h4>
                      <ul
                        style="margin: 0; padding-left: 20px; line-height: 1.8"
                      >
                        <li>24/7 cloud infrastructure monitoring</li>
                        <li>Security management</li>
                        <li>Backup and disaster recovery</li>
                        <li>Continuous optimization</li>
                        <li>Proactive support</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Pricing Section -->
                <div style="background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); padding: 40px; border-radius: 16px; margin-top: 50px; border-left: 4px solid #3b82f6; text-align: center;">
                  <h3 style="color: #1a202c; font-weight: 700; margin-bottom: 16px; font-size: 1.8rem;">Transparent Pricing</h3>
                  <p style="color: #4a5568; font-size: 1.1rem; line-height: 1.7; margin-bottom: 24px; max-width: 700px; margin-left: auto; margin-right: auto;">
                    Standard rate of <strong style="color: #1a202c; font-size: 1.2rem;">$225/hour</strong> for consulting and implementation. Volume discounts and retainer packages available.
                  </p>
                  <NuxtLink to="/services/pricing" style="display: inline-block; background: #3b82f6; color: white; padding: 14px 32px; border-radius: 8px; font-weight: 600; text-decoration: none; font-size: 1.05rem; transition: background 0.2s;">
                    View Full Pricing Details
                  </NuxtLink>
                </div>

                <div
                  style="
                    background: linear-gradient(
                      135deg,
                      var(--aws-migration-start) 0%,
                      var(--aws-migration-end) 100%
                    );
                    color: white;
                    padding: 40px;
                    border-radius: 16px;
                    margin-top: 50px;
                    text-align: center;
                  "
                >
                  <h3
                    style="
                      font-weight: 700;
                      margin-bottom: 20px;
                      font-size: 1.8rem;
                    "
                  >
                    Ready to Start Your Cloud Journey?
                  </h3>
                  <p
                    style="
                      font-size: 1.1rem;
                      opacity: 0.95;
                      line-height: 1.6;
                      margin-bottom: 30px;
                    "
                  >
                    Whether you're just beginning to explore cloud options or
                    ready to migrate complex workloads, our team of
                    AWS-certified experts can guide you through every step of
                    your cloud journey.
                  </p>
                  <div
                    style="
                      display: flex;
                      gap: 20px;
                      justify-content: center;
                      flex-wrap: wrap;
                    "
                  >
                    <div
                      style="
                        background: rgba(255, 255, 255, 0.2);
                        padding: 20px;
                        border-radius: 12px;
                        backdrop-filter: blur(10px);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        flex: 1;
                        min-width: 200px;
                        max-width: 250px;
                      "
                    >
                      <h4 style="font-weight: 600; margin-bottom: 12px">
                        🚀 Accelerate
                      </h4>
                      <p style="margin: 0; font-size: 0.95rem; opacity: 0.9">
                        Speed up your time-to-value
                      </p>
                    </div>
                    <div
                      style="
                        background: rgba(255, 255, 255, 0.2);
                        padding: 20px;
                        border-radius: 12px;
                        backdrop-filter: blur(10px);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        flex: 1;
                        min-width: 200px;
                        max-width: 250px;
                      "
                    >
                      <h4 style="font-weight: 600; margin-bottom: 12px">
                        💰 Save
                      </h4>
                      <p style="margin: 0; font-size: 0.95rem; opacity: 0.9">
                        Reduce infrastructure costs
                      </p>
                    </div>
                    <div
                      style="
                        background: rgba(255, 255, 255, 0.2);
                        padding: 20px;
                        border-radius: 12px;
                        backdrop-filter: blur(10px);
                        border: 1px solid rgba(255, 255, 255, 0.3);
                        flex: 1;
                        min-width: 200px;
                        max-width: 250px;
                      "
                    >
                      <h4 style="font-weight: 600; margin-bottom: 12px">
                        🔒 Secure
                      </h4>
                      <p style="margin: 0; font-size: 0.95rem; opacity: 0.9">
                        Enhance your security posture
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
useHead({
  title: 'Migration to AWS Cloud | Geek Cafe',
  meta: [
    { name: 'description', content: 'Expert AWS cloud migration services with minimal disruption. Rehost, replatform, or refactor your applications with our proven migration methodology.' }
  ]
})
</script>

<style scoped src="@/assets/css/service-detail-card.css"></style>